import React, { memo, forwardRef, useCallback } from 'react';
import { createUseStyles, Link } from 'hoi-poi-ui';
import ExcelIcon from "../../icons/ExcelIcon";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'FileNameFormatter');
var _ref2 = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExcelIcon, null));
const FileNameFormatter = (_ref, ref) => {
  let {
    onDownload,
    data,
    value
  } = _ref;
  const classes = useStyles();
  const onClick = useCallback(() => {
    onDownload(data);
  }, [data, onDownload]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classes.fileName,
    onClick: onClick
  }, _ref2, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
    className: "ag-grid-link-hover"
  }, value)));
};
export default /*#__PURE__*/memo(/*#__PURE__*/forwardRef(FileNameFormatter));